import React from "react";
import "./footer.scss";
import Logo from "../../assets/images/logo.png";
import { Link, NavLink } from "react-router-dom";
import Icofont from "react-icofont";

export const Footer = () => {
  return (
    <footer>
      <div className="footer-container mt">
        <div className="news-letter-div flexy">
          <div className="col-md-6 newsletter-heading">
            <div className="offset-md-3">
              <h2>SUBSCRIBE</h2>
              <h1>TO OUR NEWSLETTER</h1>
            </div>
          </div>
          <div className="col-md-3 newsletter-input flexy flexyM">
            <input
              placeholder="Enter your email address"
              className="col-md-8"
            />
            <button className="col-md-4">SUBSCRIBE</button>
          </div>
        </div>
        <div className="col-md-2 offset-md-2 offset-3">
          {" "}
          <img className="" src={Logo} alt="Scholar" width="70%" />
        </div>
        <div className="offset-md-2 col-md-8  flexy">
          <div className="col-md-5">
            {" "}
            <p>
              Dive into the captivating world of physics where we delve into the
              deepest mysteries of the universe. Our department is dedicated to
              unraveling the secrets of particles, forces, and cosmic phenomena.
              From quantum mechanics to astrophysics, we are at the forefront of
              research, pushing boundaries and advancing human knowledge
            </p>
            <ul className="list-inline socials-list">
              <li className="list-inline-item ">
                <div className="socials">
                  <a href="#" target="_blank">
                    <i class="icofont-facebook"></i>
                  </a>
                </div>
              </li>{" "}
              <li className="list-inline-item socials">
                <a href="#" target="_blank">
                  <i class="icofont-linkedin"></i>
                </a>
              </li>{" "}
              <li className="list-inline-item socials">
                <a href="#" target="_blank">
                  <i class="icofont-instagram"></i>
                </a>
              </li>{" "}
              <li className="list-inline-item socials">
                <a href="#" target="_blank">
                  <i class="icofont-twitter"></i>
                </a>
              </li>
            </ul>
          </div>
          <div className="col-md-4 offset-md-1">
            <h5>GET IN TOUCH</h5>
            <ul>
              <li>
                <span>
                  <i class="icofont-phone"></i>
                  080677333782
                </span>
              </li>{" "}
              <li>
                <span>
                  <i class="icofont-phone"></i>
                  07045633782
                </span>
              </li>
              <li>
                <span>
                  <i class="icofont-ui-message"></i>
                </span>
                info.physics@gmail.com
              </li>
              <li>
                <span>
                  <i class="icofont-location-pin"></i>
                </span>
                Your address goes here,street.
              </li>
            </ul>
          </div>
          <div className="col-md-2">
            <h5>USEFUL LINKS</h5>
            <ul>
              <li>
                <Link to={"/directory"} className="footer-links">
                  Lecturers & Staff
                </Link>
              </li>
              <li>
                <Link to={"/course-page"} className="footer-links">
                  Our Courses
                </Link>
              </li>

              <li>
                <Link to={"/contact"} className="footer-links">
                  Enquiries
                </Link>
              </li>
              <li>
                <Link to={"physics-overview"} className="footer-links">
                  Physics Overview
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="credits flexy">
        <p className="offset-md-3">
          Copyright © Hexxondiv 2023.All right reserved.Created by Hexxondiv
          TechHub
        </p>
        <div className="flexy flexyM offset-md-2 offset-2">
          <Link to={"/"} className="footer-links">
            Privacy policy
          </Link>
          {""}
          <h5>|</h5>
          <Link to={"/terms"} className="footer-links">
            Terms & Conditions
          </Link>
        </div>
      </div>
    </footer>
  );
};
